var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyInfos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_14222)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.5 25.5C15.8152 25.5 18.9946 24.183 21.3388 21.8388C23.683 19.4946 25 16.3152 25 13C25 9.68479 23.683 6.50537 21.3388 4.16117C18.9946 1.81696 15.8152 0.5 12.5 0.5C9.18479 0.5 6.00537 1.81696 3.66117 4.16117C1.31696 6.50537 0 9.68479 0 13C0 16.3152 1.31696 19.4946 3.66117 21.8388C6.00537 24.183 9.18479 25.5 12.5 25.5ZM13.9531 10.7937L12.3906 18.1453C12.2812 18.6766 12.4359 18.9781 12.8656 18.9781C13.1688 18.9781 13.6266 18.8687 13.9375 18.5938L13.8 19.2437C13.3516 19.7844 12.3625 20.1781 11.5109 20.1781C10.4125 20.1781 9.94531 19.5187 10.2484 18.1172L11.4016 12.6984C11.5016 12.2406 11.4109 12.075 10.9531 11.9641L10.2484 11.8375L10.3766 11.2422L13.9547 10.7937H13.9531ZM12.5 9.09375C12.0856 9.09375 11.6882 8.92913 11.3951 8.6361C11.1021 8.34308 10.9375 7.94565 10.9375 7.53125C10.9375 7.11685 11.1021 6.71942 11.3951 6.4264C11.6882 6.13337 12.0856 5.96875 12.5 5.96875C12.9144 5.96875 13.3118 6.13337 13.6049 6.4264C13.8979 6.71942 14.0625 7.11685 14.0625 7.53125C14.0625 7.94565 13.8979 8.34308 13.6049 8.6361C13.3118 8.92913 12.9144 9.09375 12.5 9.09375Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_14222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfos);
export default __webpack_public_path__ + "static/media/companyInfos.ba6b02bbace19fec12e0f08f4e575b8c.svg";
export { ForwardRef as ReactComponent };